// extracted by mini-css-extract-plugin
export var homeIndicator = "layout-module--homeIndicator--ya5Dh";